// extracted by mini-css-extract-plugin
module.exports = {"container":"ad","copy":"bd","field":"cd","error":"dd","disabled":"ed","termsContainer":"fd","termsHeading":"gd","termsCopy":"hd","submit":"id","srOnly":"jd"};